import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Link         from './Link'
import Thumbnail    from './Thumbnail'
import ProjectType  from './ProjectType'

const MapMarker = ({ project, ...props }) => {
  const isCurrentParam = param => param && param.slice(1) == project.slug

  return (
    <div
      className={[
        'map-marker',
        `map-marker-${project.type}`,
        isCurrentParam(props.activeMarker) && 'map-marker-active',
        isCurrentParam(props.projectPanel) && 'map-marker-current',
      ].filter(Boolean).join(' ')}
      style={project.coords}
    >
      <Link
        className="map-marker-toggle text-white"
        href={`#${project.slug}`}
        onClick={props.setActiveMarker}
      >
        <FontAwesomeIcon
          icon={{ home: 'home', garden: 'seedling', 'community-center': 'building' }[project.type]}
          fixedWidth
          className="map-marker-icon"
        />
        <span className="sr-only">{project.name}</span>
      </Link>

      <div
        className="map-marker-popover popover show bs-popover-top bg-dark shadow-lg"
        role="tooltip"
      >
        <div className="arrow"></div>
        <div className="popover-body text-white p-3 p-sm-4">
          <div className="media">
            <Thumbnail
              className="map-marker-popover-thumbnail mr-3 mr-sm-4"
              width="75"
              height="75"
              src={project.images[0]}
            />
            <div className="media-body">
              <h5 className="mt-0 mb-2 mb-sm-3">{project.name}</h5>
              <ProjectType project={project} />

              <p className="mt-2 mt-sm-3 mb-1">
                <Link
                  className="text-white"
                  href={`#${project.slug}`}
                  onClick={props.openProjectPanel}
                >
                  <FontAwesomeIcon icon="info-circle" className="mr-2" />
                  Learn more
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MapMarker
